export default function SciPy_Significance_Tests() {
  return (
    <div>
      <h1>SciPy Significance Tests</h1>
    </div>
  );
}
